/**
 * SpotlightOverlay — public entry point.
 *
 * Thin wrapper that defers loading the heavy implementation (Hestia
 * primitives + `createPortal` + SVG clip-path generation) until the
 * first spotlight activation. The wrapper itself adds essentially
 * nothing to the initial bundle: it only subscribes to
 * `useSpotlightInternal` so it can flip between "nothing" and the
 * lazy chunk on demand.
 *
 * Behaviour and props match the spec (§9.5–§9.7); see
 * `SpotlightOverlayImpl.tsx` for the implementation.
 */
import { Suspense, lazy } from 'react'

import { useSpotlightInternal } from './useSpotlight'

const SpotlightOverlayImpl = lazy(() => import('./SpotlightOverlayImpl'))

export function SpotlightOverlay() {
  const { current } = useSpotlightInternal()
  // No active spotlight → render nothing, no chunk fetch.
  if (!current) return null
  return (
    <Suspense fallback={null}>
      <SpotlightOverlayImpl />
    </Suspense>
  )
}
